'use strict';
import React from 'react';
import classNames from 'classnames';

import Icon from '../components/icon';

/**
 * Radio button component.
 * Always nest the radio-input and radio-icon within a radio label to ensure proper positioning.
 * Radio-icon must follow radio-input.
 * Default display style for labels is inline-block, add .Radio-label--stacked for vertical display.
 *
 * @extends {React.Component}
 * @property {String} name Sets the name attribute of the radio button.
 * @property {String} value Sets the value assigned to this radio button.
 * @property {Boolean} disabled Renders the radio button as disabled.
 * @property {Boolean} stacked Renders the radio button as vertically stacked.
 * @property {Function} onChange Callback on value change.
 */
class Radio extends React.Component {

  /**
   * @return {String} Component CSS classname.
   */
  getClassName () {
    return classNames({
      'Radio-label': true,
      'Radio-label--stacked': this.props.stacked,
      'is-disabled': this.props.disabled
    });
  }

  /**
   * @return {JSX} JSX component markup.
   */
  render () {
    const { children, disabled, stacked, ...otherProps } = this.props;

    return (
      <label className={this.getClassName()}>
        <input {...otherProps}
          className="Radio-input"
          disabled={disabled}
          type="radio"/>
        <Icon className="Radio-icon"/>
        {children}
      </label>
    );
  }
}

/**
 * @prop {propTypes} propTypes attributes for the Radio component
 */
Radio.propTypes = {
  disabled: React.PropTypes.bool,
  name: React.PropTypes.string.isRequired,
  stacked: React.PropTypes.bool,
  value: React.PropTypes.any.isRequired
};

Radio.defaultProps = {
  disabled: false,
  stacked: false
};

export default Radio;



// WEBPACK FOOTER //
// ./src/components/clarity-ui/inputs/radio.jsx